<template>
  <div>
    <a-icon
      style="font-size: 17px;padding-right: 10px;cursor: pointer;"
      class="trigger"
      :type="collapsed ? 'menu-unfold' : 'menu-fold'"
      @click="siderBarOpen"
    />
    <a-breadcrumb class="breadcrumb" style="display: inline-block;">
      <a-breadcrumb-item v-for="item in breadList" :key="item.name">
        <router-link :to="{ path: item.path === '' ? '/' : item.path }">
          <a-icon v-if="item.meta.icon" :type="item.meta.icon"></a-icon>
          {{ item.meta.title }}
        </router-link>
      </a-breadcrumb-item>
    </a-breadcrumb>
  </div>
</template>

<script>
import AppModel from '@/store/modules/app';
export default {
  data() {
    return {
      name: '',
      breadList: [],
    };
  },
  mounted() {},
  created() {
    this.getBreadcrumb();
  },
  computed: {
    collapsed: function() {
      return AppModel.collapsed;
    },
  },
  methods: {
    siderBarOpen() {
      AppModel.TOGGLE_COLLAPSED();
    },
    getBreadcrumb() {
      this.breadList = [];
      // this.breadList.push({ name: 'index', path: '/', meta: { title: '首页' } });

      this.name = this.$route.name;
      this.$route.matched
        .filter(o => o.meta && o.meta.hiddenBreadcrumb !== true)
        .forEach(item => {
          // item.name !== 'index' && this.breadList.push(item)
          this.breadList.push(item);
        });
    },
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    },
  },
};
</script>

<style scoped>
.breadcrumb {
  text-align: left;
  margin-bottom: 16px;
  /* background-color: white; */
}
</style>
